import React from 'react';

const PREVIEWS = [
  { id: 2, label: 'Park Slope', src: 'https://images.unsplash.com/photo-1789684290015-1231896d5549?w=800', alt: 'Suburban home gable illuminated by warm white LEDs at dusk' },
  { id: 3, label: 'Carroll Gardens', src: 'https://images.unsplash.com/photo-1776222075410-5acc108845c8?w=800', alt: 'Modern home with warm string lights outlining the roofline at dusk' },
  { id: 4, label: 'Brooklyn Heights', src: 'https://images.unsplash.com/photo-1776222075392-f84395eff09c?w=800', alt: 'Residence with illuminated windows and architectural lighting at dusk' },
  { id: 5, label: 'Williamsburg', src: 'https://images.unsplash.com/photo-1576692155415-95f820a2c4c1?w=800', alt: 'Townhouse exterior with full roofline Christmas light installation at night' },
];

const imgClass = 'w-full h-full object-cover group-hover:scale-105 transition-transform duration-700';

const FeaturedPreview = () => (
  <div className="aspect-[4/5] overflow-hidden rounded-xl group relative md:col-span-1 md:row-span-2 ring-1 ring-white/10" data-testid="christmas-preview-1">
    <img
      src="https://customer-assets-lqy194kg.emergentagent.net/job_f0006312-c8b3-4027-b89c-f2f3fb76e672/artifacts/559086851551c28f_bright-home-lights-permanent-led-lifestyle-hero_f6b78277-0d7b-488b-9dff-66462f8a382f.png"
      alt="Jetco Electrical professional Christmas light installation on a Brooklyn home at twilight"
      loading="lazy"
      className={imgClass}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent"></div>
    <div className="absolute bottom-5 left-5 right-5">
      <p className="text-xs font-semibold text-yellow-400 tracking-widest uppercase mb-1.5">Featured Install</p>
      <p className="text-white font-bold text-lg leading-tight">Full roofline, eaves, gables &amp; architectural uplighting</p>
    </div>
  </div>
);

const Preview = ({ id, label, src, alt }) => (
  <div className="aspect-[4/5] overflow-hidden rounded-xl group relative ring-1 ring-white/10" data-testid={`christmas-preview-${id}`}>
    <img src={src} alt={alt} loading="lazy" className={imgClass} />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
    <div className="absolute bottom-3 left-3">
      <span className="text-[11px] font-semibold text-black bg-yellow-400 px-2 py-0.5 rounded tracking-wide uppercase">{label}</span>
    </div>
  </div>
);

export const ChristmasPreviewGrid = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-6xl mx-auto mb-14">
    <FeaturedPreview />
    {PREVIEWS.map((preview) => <Preview key={preview.id} {...preview} />)}
  </div>
);
